import React, { useCallback, useMemo } from 'react';
import { di } from 'react-magnetic-di';
import { useActions } from '../../../../../controllers/conversation-store';
import type { RequestTypeField } from '../../../../../services/request-type-fields-service/types';
import type { Option } from '../../../../types';
import { OptionDropdown } from '../../option-dropdown';

export const SingleSelectFieldAppendix = ({ field }: { field: RequestTypeField }) => {
    di(useActions);
    const { addJiraFieldMessage } = useActions();

    const fieldOptions: Option[] = useMemo(
        () => (field?.validValues ?? []).map((validValues) => ({ id: validValues.value, label: validValues.label })),
        [field]
    );

    const handleSelectOption = useCallback(
        (selectedOption: Option) => {
            addJiraFieldMessage(field.fieldId, selectedOption.id, selectedOption.label);
        },
        [addJiraFieldMessage, field]
    );

    return <OptionDropdown options={fieldOptions} onSelectOption={handleSelectOption} />;
};
